// @flow
import * as React from 'react';
import { FormControl } from 'react-bootstrap';
import style from './style';
import type { Props } from './props';

// eslint-disable-next-line no-unused-vars
const TextInput = ({ feed = '', placeholder = '', onChange = (e: string) => {} }: Props): React.Element<any> => (
  <FormControl
    defaultValue={feed}
    style={style.feedsInputs}
    type="text"
    placeholder={placeholder}
    onChange={e => onChange(e.target.value)}
  />
);

export default TextInput;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/News/components/TextInput/TextInput.js